export default ['AppReducer'];
